import { Button, TextField, Grid, Divider, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core"
import { useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { DialogMessage } from "../../../global/DialogMessage"
import { ToastMessage } from "../../../global/ToastMessage"
import { obtenerHabitacionesContratadas, actulizaContracionPlazaAction } from "../../../ducks/clientesDuck"
import BackDrop from "../../../global/BackDrop"
import { catTipoPlaza } from "../../../constant/catTipoPlaza"
import { formatDinero } from "./../../../utils/formatDinero"
import { esFinalizado } from "../../../utils/esFinalizado"

const FormPlaza = (props) => {
    const { cliente, verificado, plazaDisponibles } = useSelector(store => store.cliente)
    const { id = 0, Cantidad = 0, handleGuardar = () => { }, IdObjeto = "", name = "default", handleChangeAction = () => { }, disabled = false } = props
    const [value, setValue] = useState(Cantidad)
    const [editar, setEditar] = useState(false)
    const [selectValue, setSelectValue] = useState(id)
    const handleChangeValue = (event) => {
        setValue(event.target.value)
    }
    const handleChangeSelectValue = (event) => {
        setSelectValue(event.target.value)
    }
    const hangdleClickEditar = () => {
        setEditar(!editar)
    }
    const handleClickSave = () => {
        setEditar(false)
        handleGuardar({
            id: selectValue,
            idOld: id,
            IdObjeto,
            name: name.split(" ").join(""),
            value: value
        })
    }
    if (plazaDisponibles.length > 0) return (
        <div style={{ margin: "2% 0" }}>
            <Grid container>
                <Grid item xs={12}>
                    <div style={{ margin: "0.5rem 0", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <div style={{ margin: "0.5rem 0.5rem" }}>
                            <FormControl variant="outlined" style={{ width: "100%" }}>
                                <InputLabel id="lFecha">Plazas</InputLabel>
                                <Select
                                    disabled={verificado || !editar}
                                    labelId="lFecha"
                                    id="SFecha"
                                    name="SFecha"
                                    onChange={handleChangeSelectValue}
                                    label="Plazas"
                                    value={selectValue}
                                >
                                    <MenuItem value="0" disabled>
                                        {"Seleccione una opción"}
                                    </MenuItem>
                                    {plazaDisponibles.map((plaza, index) => (
                                        <MenuItem key={index} value={`${plaza.IdExtraPaqueteProveedor}`}>
                                            {`${plaza.Nombre} - ${formatDinero(plaza.Precio)}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                        <TextField
                            value={value}
                            disabled={verificado || !editar || esFinalizado(cliente?.paquete?.CatEstatusProceso?.IdEstatusProceso)}
                            style={{ width: "100%" }}
                            id="outlined-number-Cantidad"
                            label="Cantidad"
                            type={verificado || !editar ? "text" : "number"}
                            onChange={handleChangeValue}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                inputProps: { min: 0, max: 10 }
                            }}
                            variant="outlined"
                        />
                        {
                            (!editar) &&
                            <Button
                                style={{ margin: "0 2%" }}
                                variant="contained"
                                color="primary"
                                disabled={verificado || esFinalizado(cliente?.paquete?.CatEstatusProceso?.IdEstatusProceso)}
                                onClick={hangdleClickEditar}
                            >
                                Editar
                            </Button>
                        }
                        {
                            (editar) &&
                            <div style={{ margin: "0 2%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Button
                                    style={{ margin: "0 2%" }}
                                    variant="contained"
                                    color="primary"
                                    disabled={verificado || disabled}
                                    onClick={handleClickSave}
                                >
                                    Guardar
                                </Button>
                                <Button
                                    style={{ margin: "0 2%" }}
                                    variant="contained"
                                    color="default"
                                    disabled={verificado}
                                    onClick={hangdleClickEditar}
                                >
                                    Cancelar
                                </Button>
                            </div>
                        }
                    </div>
                </Grid>
            </Grid>
        </div>
    )
    return (
        <div>
            No hay suplemento de tipo plaza diponibles para el paquete <b>{cliente?.paquete?.Nombre}</b>
        </div>
    )
}
const FHabitaciones = () => {
    const { cliente, referencia, verificado, plazaContratadas, idContratacion } = useSelector(store => store.cliente)
    const [load, setLoad] = useState(false)
    const dispatch = useDispatch()

    const handleGuardar = (event) => {
        if (verificado) {
            ToastMessage.fire({
                icon: "info",
                title: "Referencia verificada",
            });
            return null
        }

        if (plazaContratadas.find(plaza => plaza.TipoPlaza?.IdTipoPlaza === Number(catTipoPlaza.Compartida))) {
            ToastMessage.fire({
                icon: "info",
                title: "Plaza compartidas no se puede modificar",
            });
            return null
        }

        let newPlazas = []
        const arrayPlazas = [...plazaContratadas]
        const mapPlazas = arrayPlazas.map((plazaC, index) => {
            return {
                id: plazaC.SuplementoContratado?.IdExtraPaqueteProveedor,
                amount: plazaC.ContratacionSuplemento?.Cantidad,
                idSuplemento: plazaC.ContratacionSuplemento?.SuplementoKey
            }
        })
        if (mapPlazas.find(plazaF => plazaF.id !== event.id)) {
            newPlazas = mapPlazas.map((plaza, index) => {
                if (plaza.id === event.idOld) {
                    return {
                        id: event.id,
                        amount: event.value,
                        idSuplemento: event.IdObjeto
                    }
                }
                return plaza
            })
        } else {
            newPlazas = mapPlazas.map(plaza => {
                if (plaza.id === event.id) {
                    plaza.amount = event.value
                }
                return plaza
            })
        }
        
        if (newPlazas.length === 0) {
            ToastMessage.fire({
                icon: "info",
                title: "Seleccione el numero de plazas",
            });
            return null
        }


        DialogMessage.fire({
            title: `Cambio de habitaciones`,
            text: `¿Esta seguro de cambiar las habitaciones para la referencia #${referencia}?`,
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                let payload = {
                    IdContratacion: idContratacion,
                    suplementosEnviados: newPlazas
                }
                setLoad(true)
                dispatch(actulizaContracionPlazaAction(payload)).then(Response => {
                    setLoad(false)
                    if (Response?.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema de conexión con el servidor",
                        });
                        return null
                    }
                    if (Response?.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            text: Response?.Message,
                        });
                        return null
                    }
                    dispatch(obtenerHabitacionesContratadas({ Referencia: referencia }))
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    });
                })
            }
        })
    }
    const handleChangeAction = (event) => {
        // let newPlazas = []
        // const arrayPlazas = [...plazaContratadas]
        // const mapPlazas = arrayPlazas.map((plazaC, index) => {
        //     return {
        //         id: plazaC.SuplementoContratado?.IdExtraPaqueteProveedor,
        //         amount: plazaC.ContratacionSuplemento?.Cantidad,
        //         idSuplemento: plazaC.ContratacionSuplemento?.SuplementoKey
        //     }
        // })
        // if (mapPlazas.find(plazaF => plazaF.id !== event.id)) {
        //     newPlazas = mapPlazas.map((plaza, index) => {
        //         if (plaza.id === event.idOld) {
        //             return {
        //                 id: event.id,
        //                 amount: event.value,
        //                 idSuplemento: event.IdObjeto
        //             }
        //         }
        //         return plaza
        //     })
        // } else {
        //     newPlazas = mapPlazas.map(plaza => {
        //         if (plaza.id === event.id) {
        //             plaza.amount = event.value
        //         }
        //         return plaza
        //     })
        // }

        // const arrayPlazas = [...plaza]
        // if (arrayPlazas.find(plaza => plaza.id !== event.id))
        //     arrayPlazas.push({
        //         id: event.id,
        //         amount: event.value,
        //         idSuplemento: event.IdObjeto
        //     })
        // const newArrayPlazas = arrayPlazas.map(plaza => {
        //     if (plaza.id === event.id) {
        //         plaza.amount = event.value
        //     }
        //     return plaza
        // })
        // console.log("🚀 ~ file: FHabitaciones.jsx:204 ~ newArrayPlazas ~ newArrayPlazas:", newArrayPlazas)
        // setPlaza(newArrayPlazas)
    }

    return <div>
        <Grid container>
            <Grid item xs={12}>
                <p>Paquete: <b>{cliente?.paquete?.Nombre}</b></p>
                <p>Numero de pasajeros: <b>{cliente?.paquete?.Numero_Personas}</b></p>
                <Divider style={{backgroundColor: "rgb(105, 163, 59)", height: "3px"}} />
                {
                    (plazaContratadas) &&
                    plazaContratadas.map((plaza, index) =>
                        <div key={plaza?.ContratacionSuplemento?.IdContratacionSuplemento}>
                            <p>Tipo: <b>{plaza?.TipoPlaza?.Descripcion}</b></p>
                            <p>Nombre: <b>{plaza?.SuplementoContratado?.Nombre}</b></p>
                            <p>Cantidad: <b>{plaza?.ContratacionSuplemento?.Cantidad}</b></p>
                            <FormPlaza
                                id={plaza.SuplementoContratado?.IdExtraPaqueteProveedor}
                                name={plaza.TipoPlaza?.Descripcion}
                                IdObjeto={plaza.ContratacionSuplemento?.SuplementoKey}
                                handleChangeAction={handleChangeAction}
                                verificado={verificado}
                                Cantidad={plaza.ContratacionSuplemento?.Cantidad}
                                handleGuardar={handleGuardar}
                            />
                            <Divider style={{backgroundColor: "rgb(0, 155, 219)", height: "3px"}} />
                        </div>
                    )
                }
            </Grid>
            <Grid item xs={12}>
                {/*                 
                {
                    (plazaDisponibles.length > 0) ?
                        <div style={{ margin: "0.5rem 0" }}>
                            {
                                plazaDisponibles.map((plaza, index) => {
                                    const plazaC = plazaContratadas.find(plazaC => plazaC.TipoPlaza?.Descripcion === plaza.Descripcion)
                                    return (
                                        <div key={plaza.IdExtraPaqueteProveedor} style={{ margin: "1rem 0" }}>
                                            
                                            <TextFielNumber
                                                id={plaza.IdExtraPaqueteProveedor}
                                                name={plaza.Descripcion}
                                                Descripcion={plaza.Nombre}
                                                IdObjeto={plaza.IdObjeto}
                                                Cantidad={(plazaC) ? plazaC.ContratacionSuplemento.Cantidad : 0}
                                                numPerson={0}
                                                totalPerson={0}
                                                price={plaza.Precio}
                                                handleChangeAction={handleChangeAction}
                                                verificado={verificado}
                                                handleGuardar={handleGuardar}
                                                disabled={plazaDisponibles.length === 0}
                                            />
                                            <Divider />
                                        </div>
                                    )
                                }
                                )
                            }
                        </div>
                        :
                        <div>
                            No hay suplemento de tipo plaza diponibles para el paquete <b>{cliente?.paquete?.Nombre}</b>
                        </div>
                } */}
            </Grid>
        </Grid>
        <BackDrop open={load} />
    </div>
}
export default FHabitaciones